export default __webpack_public_path__ + "static/media/raiffeisen_m1.5d6c9e2f.png";